export const alertTypes = {
    SET_ALL_ACTIVITY_SUCCESS:'SET_ALL_ACTIVITY_SUCCESS',
    NO_MORE_DATA:'NO_MORE_DATA',
    GET_MORE_DATA:'GET_MORE_DATA',
    SET_ALL_ACTIVITY_ERROR:'SET_ALL_ACTIVITY_ERROR',
    SET_ALL_AROUND_SUCCESS:'SET_ALL_AROUND_SUCCESS',
    SET_ALL_AROUND_ERROR:'SET_ALL_AROUND_ERROR',
}